module.exports = __webpack_public_path__ + "img/thumb_22.3fc9b189.jpg";